import React, {PureComponent} from 'react';
import {Modal} from 'react-responsive-modal';
import {subscribeOrgMessageToGarage, subscribeToOrgMessage} from "../functions/api";
import {withTranslation} from "react-i18next";

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

class OrgMessageModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            isPrivate: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        subscribeToOrgMessage(this.props.eventID, this.props.sessionID, false, (err, data) => {
            this.closeModal();
            this.setState({
                carID: data.cid,
                userID: data.uid,
                liveryID: data.cln,
                message: data.msg,
                isPrivate: false,
            }, () => {
                this.openModal();
            });
        });
        subscribeOrgMessageToGarage(this.props.eventID, this.props.sessionID, false, (err, data) => {
            this.closeModal();
            this.setState({
                userID: data.uid,
                message: data.msg,
                isPrivate: true,
            }, () => {
                this.openModal();
            });
        });
    }

    componentWillUnmount() {
        subscribeToOrgMessage(this.props.eventID, this.props.sessionID, true, null);
    }

    /* HANDLERS */
    openModal() {
        if (!(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin))) {
            this.setState({
                modalOpen: true
            });
        }
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    render() {
        return (
            <Modal open={this.state.modalOpen}
                   onClose={() => {
                   }}
                   animationDuration={200}
                   center={true}
                   classNames={{modal: "medium-modal fadeInLeft"}}
                   showCloseIcon={false}
            >
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        {this.state.isPrivate ? (
                            <h3 className={"text-center App_black_text"} style={{fontSize: 25}}><b>{this.props.t("orgSentMessage")}!</b></h3>
                        ) : (
                            <h3 className={"text-center App_black_text"} style={{fontSize: 25}}><b>{this.props.t("vehicle")} <span style={{color: "#a1000c", fontSize: 27}}>#{this.state.liveryID}</span> {this.props.t("receivedMessageOrg")}!</b></h3>
                        )}
                    </div>
                    <div className={"col-sm-12 text-center"} style={{paddingLeft: 35, paddingRight: 35}}>
                        <h1 className={"App_textLaptime"} style={{color: "#000000"}}>" {this.state.message} "</h1>
                    </div>
                    <br/>
                    <br/>
                    {this.state.isPrivate ? (
                        <div className={"col-sm-12 text-center"} style={{paddingLeft: 35, paddingRight: 35, marginTop: 36}}>
                            <div className={"App_black_text"} style={{fontStyle: "italic"}}><b>{this.props.t("messageWarning")}.</b></div>
                        </div>) : (
                        <></>
                    )}
                    <div className={"col-sm-12 text-center"}>
                        <button
                            className={"btn App_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20, marginTop: 20}}
                            onClick={this.closeModal}
                        >{this.props.t("ok")}
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default withTranslation("translations")(OrgMessageModal);